import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardContent } from "../../Components/ui/card";
import { Button } from "../../Components/ui/button";
import { Input } from "../../Components/ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../Components/ui/table";
// import {
//   Accordion,
//   AccordionItem,
//   AccordionTrigger,
//   AccordionContent,
// } from "../../Components/ui/accordion";

import { Badge } from "../../Components/ui/badge";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../Components/ui/avatar";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../Components/ui/dialog";
import { Label } from "../../Components/ui/label";
import { CaretSortIcon, DotsHorizontalIcon } from "@radix-ui/react-icons";
import axios from "axios";
import { useSelector } from "react-redux";
import { RootState } from "../../State/store";
import { toast } from "../../Components/ui/use-toast";
import { Toaster } from "../../Components/ui/toaster";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import { useMemo } from "react";
import { useRef } from "react";
import { convertUTCToLocal } from "../../../src/utils/convertUTCToLocal";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../Components/ui/dropdown-menu";

// Interfaces remain the same
interface Member {
  name: string;
  email: string;
  role: string;
  joinedDate: string;
  wId: number;
}

interface Admin {
  id: number;
  email: string;
  createdAt: string;
  updatedAt: string;
  first_name: string;
  last_name: string;
  profile_image: string;
}

interface InviteMember {
  name: string;
  role: string;
  invitedAt: string;
  expiresAt: string;
  status: string;
}

interface Roles {
  role_id: string;
  role_name: string;
}

// LazyAvatar component remains the same
const LazyAvatar = React.memo(
  ({ admin, profileImage }: { admin: Admin; profileImage?: string }) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);

    const handleImageLoad = () => setImageLoaded(true);
    const handleImageError = () => setImageError(true);

    const getInitials = () => admin.first_name?.[0]?.toUpperCase() || "N/A";

    return (
      <Avatar>
        {profileImage && !imageError && (
          <AvatarImage
            src={profileImage}
            onLoad={handleImageLoad}
            onError={handleImageError}
            style={{
              display: imageLoaded ? "block" : "none",
              transition: "opacity 0.3s ease-in-out",
            }}
            alt={getInitials()}
          />
        )}
        {(!imageLoaded || imageError || !profileImage) && (
          <AvatarFallback className="mt-1">{getInitials()}</AvatarFallback>
        )}
      </Avatar>
    );
  }
);

const Team: React.FC = () => {
  const [adminId, setAdminId] = useState(0);
  const [adminEmail, setAdminEmail] = useState("");
  const [isDeleteMode, setIsDeleteMode] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [currentMembers, setCurrentMembers] = useState<Member[]>([]);
  const [originalMembers, setOriginalMembers] = useState<Member[]>([]);
  const [isSorted, setIsSorted] = useState(false);
  const [currentAdmins, setCurrentAdmins] = useState<Admin[]>([]);
  const [profileImages, setProfileImages] = useState<{
    [email: string]: string;
  }>({});
  const [totalCount, setTotalCount] = useState<number>(0);
  const [originalAdmins, setOriginalAdmins] = useState<Admin[]>([]);
  const [imageSrc, setImageSrc] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [inviteCurrentMembers, setInviteCurrentMembers] = useState<
    InviteMember[]
  >([]);
  const [inviteOriginalMembers, setInviteOriginalMembers] = useState<
    InviteMember[]
  >([]);
  const [isInviteSorted, setIsInviteSorted] = useState(false);
  // const [apiUrl, setApiUrl] = useState("");
  const personalemail = useSelector(
    (state: RootState) => state.authentication.userEmail
  );
  const workspaceId = useSelector(
    (state: RootState) => state.authentication.workspace_id
  );
  const [invitedMembers, setInvitedMembers] = useState([
    { email: "", role: "", name: "fazil", wId: workspaceId },
  ]);
  const [roles, setRoles] = useState<Roles[]>([]);

  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  const [activeSortField, setActiveSortField] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState<string>("");
  const [serverSuccessMessage, setServerSuccessMessage] = useState<
    string | null
  >(null);
  const [serverFailureMessage, setServerFailureMessage] = useState<
    string | null
  >(null);
  const apiurl = useSelector(
    (state: RootState) => state.authentication.authURL
  );
  const apiUrlAdvAcc = useSelector(
    (state: RootState) => state.authentication.apiURL
  );
  const apiUrlAdmin = useSelector(
    (state: RootState) => state.authentication.adminUrl
  );
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [isTeamsLoading, setIsTeamsLoading] = useState(true);

  const workspaceTimezone = useSelector(
    (state: RootState) => state.authentication.workspaceTimezone
  );

  const accountId = useSelector((state: RootState) => state.authentication.account_id);

  // Email suggestions
  const [emailSuggestions, setEmailSuggestions] = useState<string[]>([]);
  const [isSuggestLoading, setIsSuggestLoading] = useState(false);
  const suggestTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [showSuggestions, setShowSuggestions] = useState(false);



  const [searchDebounceTimer, setSearchDebounceTimer] =
    useState<NodeJS.Timeout | null>(null);
  const hasInitialLoadOccurred = useRef(false);


  // useEffect(() => {
  //   if (!hasInitialLoadOccurred.current && apiUrlAdvAcc) {
  //     hasInitialLoadOccurred.current = true;

  //     const loadInitialData = async () => {
  //       try {
  //         await Promise.all([getAdminsList(), getProfileImageTeam()]);
  //       } catch (error) {
  //         console.error("Initial load error:", error);
  //       } finally {
  //         setIsLoading(false); // Add this to hide the initial spinner
  //       }
  //     };

  //     loadInitialData();
  //   }
  // }, [apiUrlAdvAcc]);

  // // Search-triggered API calls with debounce
  // useEffect(() => {
  //   if (!hasInitialLoadOccurred.current) return; // Skip if initial load hasn't happened

  //   // Clear existing timer
  //   if (searchDebounceTimer) {
  //     clearTimeout(searchDebounceTimer);
  //   }

  //   // Set new timer for debounced search
  //   const timer = setTimeout(async () => {
  //     try {
  //       await Promise.all([getAdminsList(), getProfileImageTeam()]);
  //     } catch (error) {
  //       console.error("Search load error:", error);
  //     }
  //   }, 300); // 300ms debounce delay

  //   setSearchDebounceTimer(timer);

  //   // Cleanup function
  //   return () => {
  //     if (timer) {
  //       clearTimeout(timer);
  //     }
  //   };
  // }, [searchTerm]); // Only depends on searchTerm

  // // Add this useEffect to handle pagination changes (separate from search)
  // useEffect(() => {
  //   if (!hasInitialLoadOccurred.current) return; // Skip if initial load hasn't happened

  //   const fetchPaginationData = async () => {
  //     try {
  //       await Promise.all([getAdminsList(), getProfileImageTeam()]);
  //     } catch (error) {
  //       console.error("Pagination load error:", error);
  //     }
  //   };

  //   fetchPaginationData();
  // }, [currentPage, rowsPerPage]); // Only for pagination changes



  useEffect(() => {
  if (!apiUrlAdvAcc) return;

  // const fetchData = async () => {
  //   try {
  //     await Promise.all([getAdminsList(), getProfileImageTeam()]);
  //   } catch (error) {
  //     console.error("Load error:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

const fetchData = async () => {
  try {
    await getAdminsList();      // fast now — no image data
    setIsLoading(false);        // show table immediately ✅
    getProfileImageTeam();      // loads in background, no await
  } catch (error) {
    console.error("Load error:", error);
  }
};

  // First load → no delay, search → 300ms debounce
  const delay = hasInitialLoadOccurred.current ? 300 : 0;
  hasInitialLoadOccurred.current = true;

  const timer = setTimeout(fetchData, delay);
  return () => clearTimeout(timer);

}, [apiUrlAdvAcc, searchTerm, currentPage, rowsPerPage]);


    useEffect(() => {
    if (!open) {
      setIsDeleteMode(false);
      setTimeout(() => {
        document.body.style.pointerEvents = "";
      }, 500);
    }
  }, [open]);

  const fetchEmailSuggestions = async (q: string) => {
    try {
      setIsSuggestLoading(true);
      const res = await axios.get(`${apiUrlAdmin}/SearchAdminInviteEmails`, {
        params: { query: q },
      });
      const ok = String(res.data?.status || "").toLowerCase() === "success";
      setEmailSuggestions(ok ? res.data.emails ?? [] : []);
      setShowSuggestions(true); // ⬅️ keep panel open while we have a live query
    } catch {
      setEmailSuggestions([]);
      setShowSuggestions(true);
    } finally {
      setIsSuggestLoading(false);
    }
  };


  const getAdminsList = async () => {
    setIsTeamsLoading(true);
    try {
      const response = await axios.get(`${apiUrlAdmin}/GetAdminsList`, {
        params: {
          pageNumber: currentPage,
          pageSize: rowsPerPage,
          searchTerm: searchTerm || undefined,
        },
      });

      if (response.data.status === "Success") {
        setCurrentAdmins(response.data.adminsList);
        setOriginalAdmins(response.data.adminsList);
        setTotalCount(response.data.totalCount);
      } else {
        setCurrentAdmins([]);
        setOriginalAdmins([]);
        setTotalCount(0);
      }
    } catch (err) {
      console.error("Error fetching admins:", err);
      setCurrentAdmins([]);
      // setOriginalAdmins([]);
      setTotalCount(0);
    } finally {
      setIsTeamsLoading(false);
    }
  };

  const getProfileImageTeam = async () => {

      const currentEmails = currentAdmins.map((a) => a.email);
  const allCached = currentEmails.every((email) => profileImages[email]);
  if (allCached && currentEmails.length > 0) {
    return; // skip — already have images for these admins
  }


    try {
      const response = await axios.get(`${apiUrlAdmin}/GetProfileImageTeam`, {
        params: {
          pageNumber: currentPage,
          pageSize: rowsPerPage,
          searchTerm: searchTerm || undefined,
        },
      });

      if (response.data.status === "Success") {
        const imageMap: { [email: string]: string } = {};

        response.data.imageList.forEach(
          (item: { email: string; profile_image: string }) => {
            if (item.profile_image) {
              imageMap[
                item.email
              ] = `data:image/jpeg;base64,${item.profile_image}`;
            }
          }
        );

        setProfileImages(imageMap);
      }
    } catch (error) {
      console.error("Error fetching profile images:", error);
    }
  };

  const sortAdminByField = (
    field: "name" | "email" | "createdAt",
    type: "string" | "date" = "string"
  ) => {
    console.log("Sorting by field:", field, "Type:", type); // Debug log
    console.log("Current admins before sort:", currentAdmins); // Debug log

    const sortedAdmins = [...currentAdmins].sort((a, b) => {
      if (field === "name") {
        const aName = `${a.first_name || ""} ${a.last_name || ""}`
          .trim()
          .toLowerCase();
        const bName = `${b.first_name || ""} ${b.last_name || ""}`
          .trim()
          .toLowerCase();
        return aName.localeCompare(bName);
      }

      if (field === "email") {
        return a.email.toLowerCase().localeCompare(b.email.toLowerCase());
      }

      if (field === "createdAt") {
        const aDate = new Date(a.createdAt);
        const bDate = new Date(b.createdAt);
        console.log("Comparing dates:", aDate, "vs", bDate); // Debug log
        return bDate.getTime() - aDate.getTime(); // Newest first
      }

      return 0;
    });

    console.log("Sorted admins:", sortedAdmins); // Debug log
    setCurrentAdmins(sortedAdmins);
  };

  const sortingAdmins = (tableHeader: string) => {
    const newDirection =
      activeSortField === tableHeader && sortDirection === "asc"
        ? "desc"
        : "asc";
    setSortDirection(newDirection);
    setActiveSortField(tableHeader);

    const getCompareValue = (
      a: Admin,
      b: Admin,
      field: "name" | "email" | "createdAt"
    ) => {
      switch (field) {
        case "name":
          const aName = `${a.first_name || ""} ${a.last_name || ""}`
            .trim()
            .toLowerCase();
          const bName = `${b.first_name || ""} ${b.last_name || ""}`
            .trim()
            .toLowerCase();
          return aName.localeCompare(bName);
        case "email":
          return a.email.toLowerCase().localeCompare(b.email.toLowerCase());
        case "createdAt":
          return (
            new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
          );
        default:
          return 0;
      }
    };

    const sortedAdmins = [...currentAdmins];

    switch (tableHeader) {
      case "ByAdminsName":
        sortedAdmins.sort((a, b) =>
          newDirection === "asc"
            ? getCompareValue(a, b, "name")
            : getCompareValue(b, a, "name")
        );
        break;

      case "ByAdminsEmail":
        sortedAdmins.sort((a, b) =>
          newDirection === "asc"
            ? getCompareValue(a, b, "email")
            : getCompareValue(b, a, "email")
        );
        break;

      case "ByAdminsJoinDate":
        sortedAdmins.sort((a, b) =>
          newDirection === "asc"
            ? getCompareValue(a, b, "createdAt")
            : getCompareValue(b, a, "createdAt")
        );
        break;

      default:
        return;
    }

    setCurrentAdmins(sortedAdmins);
  };

  const sortInviteByField = (
    field: keyof InviteMember,
    type: "string" | "number" | "date" = "string"
  ) => {
    const sortedMembers = [...inviteCurrentMembers].sort((a, b) => {
      if (type === "number") {
        return Number(a[field]) - Number(b[field]);
      } else if (type === "date") {
        return Date.parse(a[field] as string) - Date.parse(b[field] as string);
      } else {
        return String(a[field]).localeCompare(String(b[field]));
      }
    });
    setInviteOriginalMembers(inviteCurrentMembers);
    setInviteCurrentMembers(sortedMembers);
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);

    // validation
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) setEmailError("Please enter a valid email address.");
    else setEmailError("");

    // debounce suggestions
    if (suggestTimeoutRef.current) clearTimeout(suggestTimeoutRef.current);

    if (!value.trim() || isDeleteMode) {
      setEmailSuggestions([]);
      setShowSuggestions(false); // ⬅️ hide when field is empty or in delete mode
      return;
    }

    suggestTimeoutRef.current = setTimeout(() => fetchEmailSuggestions(value), 500);
  };


  const handleAddAdmin = async () => {
    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.get(`${apiUrlAdmin}/CheckIfAdminEmailExists?email=${email}`);
      if (response.data.status === "Success") {
        const checkAdminResponse = await axios.get(`${apiurl}/CheckIfAdmin?EmailId=${email}`);
        if (checkAdminResponse.data.status_Description === "User is not admin") {
          try {
            const addAdminResponse = await axios.post(`${apiUrlAdmin}/AddAdmin`, {
              email: email,
              workspaceId: workspaceId,
              accountId: accountId
            });

            if (addAdminResponse.data.status === "Success") {
              toast({
                title: "Success",
                description: "Admin added successfully",
              });
              setOpen(false);
              setEmail("");
              setEmailError("");
              await getAdminsList();
            } else {
              toast({
                title: "Error",
                description: "Failed to add Admin",
              });
            }
          } catch (error) {
            setServerFailureMessage("There was an error adding the admin.");
          }
        } else {
          toast({
            title: "Info",
            description: "The entered email is already an Admin",
          });
        }
      } else {
        toast({
          title: "Error",
          description: "Email does not exist",
        });
      }
    } catch (error) {
      setServerFailureMessage("There was an error while checking the email.");
    } finally {
      setIsLoading(false);
    }
  };

  const deleteAdmin = async () => {
    try {
      setIsLoading(true);
      const response = await axios.delete(
        `${apiUrlAdmin}/DeleteAdminByEmail?email=${email}&workspaceId=${workspaceId}&accountId=${accountId}`
      );
      if (response.data.status === "Success") {
        toast({
          title: "Success",
          description: "Admin deleted successfully",
        });
        setOpen(false);
        await getAdminsList();
      } else {
        toast({
          title: "Error",
          description: "Failed to add Admin",
        });
      }
    } catch (error) {
      setServerFailureMessage("There was an error adding the admin.");
    } finally {
      setEmail("");
      setEmailError("");
      setIsLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setEmail("");
    setEmailError("");
    setServerSuccessMessage("");
    setServerFailureMessage("");
  };

  const totalPages: number = Math.ceil(totalCount / rowsPerPage);

  const handlePageChange = (newPage: number) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  const handleSubmit = () => {
    if (isDeleteMode) {
      deleteAdmin();
    } else {
      handleAddAdmin();
    }
  };

  const handleDelete = (admin_id: number, admin_email: string) => {
    setIsDeleteMode(true);
    console.log("Handle Delete :", admin_id, admin_email);
    setEmail(admin_email);
    setAdminId(admin_id);
    setOpen(true);
  };

  // Separate rendering logic for search results
  const renderTableContent = () => {
    if (isTeamsLoading) {
      return (
        <TableRow>
          <TableCell colSpan={4} className="text-center py-4">
            Loading...
          </TableCell>
        </TableRow>
      );
    }

    if (searchTerm && currentAdmins.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={4} className="text-center py-4">
            No data found
          </TableCell>
        </TableRow>
      );
    }

    if (currentAdmins.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={4} className="text-center py-4">
            No admins found
          </TableCell>
        </TableRow>
      );
    }

    return currentAdmins.map((admin, index) => (
      <TableRow key={admin.id}>
        <TableCell className="flex items-center space-x-2 py-2">
          <LazyAvatar admin={admin} profileImage={profileImages[admin.email]} />
          <div className="flex items-center space-x-2">
            <span
              className={
                admin.first_name || admin.last_name ? "" : "text-red-500"
              }
            >
              {admin.first_name || admin.last_name
                ? `${admin.first_name ?? ""} ${admin.last_name ?? ""}`.trim()
                : "No Name"}
            </span>
            {admin.email === personalemail && (
              <Badge className="ml-2 bg-blue-500 text-white">You</Badge>
            )}
          </div>
        </TableCell>
        <TableCell className="text-left">{admin.email}</TableCell>
        <TableCell className="text-left">
          <Badge className="text-white" style={{ backgroundColor: "#000000" }}>
            {"Admin"}
          </Badge>
        </TableCell>
        {/* <TableCell className="text-left">
          {admin.createdAt
            ? new Date(admin.createdAt).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })
            : "N/A"}
        </TableCell> */}
        <TableCell className="text-left">
          {admin.createdAt
            ? `${convertUTCToLocal(admin.createdAt, workspaceTimezone).localDate
            } ∙ ${convertUTCToLocal(admin.createdAt, workspaceTimezone).localTime
            }`
            : "N/A"}
        </TableCell>
        <TableCell className="px-4 py-4">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <DotsHorizontalIcon className="cursor-pointer w-6 h-6" />
            </DropdownMenuTrigger>
            <DropdownMenuContent
              className="w-28 rounded-lg shadow-md border border-gray-200"
              align="end"
            >
              <DropdownMenuItem
                className="cursor-pointer"
                onClick={() => handleDelete(admin.id, admin.email)}
              >
                Delete
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>{" "}
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <div className="flex-col gap-6 h-full overflow-y-auto no-scrollbar">
      <Toaster />
      {isLoading ? (
        <div className="flex flex-col items-center justify-center h-[500px]">
          <CircularProgress color="primary" />
        </div>
      ) : (
        <>
          <div className="-mx-6 -my-7">
            <CardHeader>
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="text-lg font-bold text-left">Admins</h2>
                  <p className="text-sm text-gray-600">
                    Here you can manage the TravelAd admins
                  </p>
                </div>
                <Button
                  className="mt-4 w-auto cursor-pointer"
                  onClick={() => setOpen(true)}
                >
                  + Add New Admin
                </Button>
              </div>
            </CardHeader>
            <div className="pr-6 pl-6">
              <Input
                placeholder="Search admins"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full"
              />
            </div>
            <CardContent>
              <div className="rounded-md border mt-4">
                <div className="max-h-[55vh] overflow-y-auto">
                  <Table
                    className="rounded-xl whitespace-nowrap border-gray-200"
                    style={{ color: "#020202", fontSize: "15px" }}
                  >
                    <TableHeader className="text-center">
                      <TableRow className="sticky top-0 z-10 bg-white hover:bg-white">
                        <TableHead className="text-left">
                          <div className="flex items-center gap-1 justify-start cursor-pointer">
                            Name
                            <CaretSortIcon
                              onClick={() => sortingAdmins("ByAdminsName")}
                              className="cursor-pointer w-4 h-4"
                            />
                          </div>
                        </TableHead>
                        <TableHead className="text-left">
                          <div className="flex items-center gap-1 justify-start cursor-pointer">
                            Email
                            <CaretSortIcon
                              onClick={() => sortingAdmins("ByAdminsEmail")}
                              className="cursor-pointer w-4 h-4"
                            />
                          </div>
                        </TableHead>
                        <TableHead className="text-left">
                          <div className="flex items-center gap-1 justify-start cursor-pointer">
                            Role
                            <CaretSortIcon
                              onClick={() => sortingAdmins("ByAdminsRole")}
                              className="cursor-pointer w-4 h-4"
                            />
                          </div>
                        </TableHead>
                        <TableHead className="text-left">
                          <div className="flex items-center gap-1 justify-start cursor-pointer">
                            Joined at
                            <CaretSortIcon
                              onClick={() => sortingAdmins("ByAdminsJoinDate")}
                              className="cursor-pointer w-4 h-4"
                            />
                          </div>
                        </TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>{renderTableContent()}</TableBody>
                  </Table>
                </div>
              </div>
            </CardContent>
          </div>
          {(totalCount > 0 || searchTerm) && (
            <div className="flex justify-between items-center mt-4">
              <div className="flex items-center space-x-2 text-gray-500 text-sm">
                <span>
                  {`${(currentPage - 1) * rowsPerPage + 1}-${Math.min(
                    currentPage * rowsPerPage,
                    totalCount
                  )} of ${totalCount} row(s)`}
                </span>
              </div>
              <div className="flex items-center space-x-4 text-sm font-medium">
                <span className="text-[#020617] text-[14px]">
                  Rows per page
                </span>
                <div className="relative inline-block ml-2">
                  <select
                    disabled={totalCount === 0}
                    className={`border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500 ${totalCount === 0
                      ? "cursor-not-allowed bg-gray-100"
                      : "cursor-pointer"
                      }`}
                    style={{
                      width: "60px",
                      height: "30px",
                      fontSize: "12px",
                      fontWeight: "400",
                      borderColor: "#E5E7EB",
                      boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.1)",
                      appearance: "none",
                    }}
                    value={rowsPerPage}
                    onChange={(e) =>
                      handleRowsPerPageChange(Number(e.target.value))
                    }
                  >
                    {[5, 10, 20].map((num) => (
                      <option key={num} value={num}>
                        {num}
                      </option>
                    ))}
                  </select>
                  <CaretSortIcon className="absolute right-1 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500 w-4 h-4" />
                </div>
                <span className="text-[#020617] text-[14px]">{`Page ${currentPage} of ${totalPages}`}</span>
                <div className="flex items-center gap-2">
                  <button
                    disabled={currentPage === 1 || totalCount === 0}
                    className={`border p-1 px-2 rounded text-gray-500 ${currentPage === 1 || totalCount === 0
                      ? "cursor-not-allowed bg-gray-100"
                      : "hover:bg-gray-200"
                      }`}
                    onClick={() => handlePageChange(1)}
                  >
                    «
                  </button>
                  <button
                    disabled={currentPage === 1 || totalCount === 0}
                    className={`border p-1 px-2 rounded text-gray-500 ${currentPage === 1 || totalCount === 0
                      ? "cursor-not-allowed bg-gray-100"
                      : "hover:bg-gray-200"
                      }`}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    ‹
                  </button>
                  <button
                    disabled={currentPage === totalPages || totalCount === 0}
                    className={`border p-1 px-2 rounded text-gray-500 ${currentPage === totalPages || totalCount === 0
                      ? "cursor-not-allowed bg-gray-100"
                      : "hover:bg-gray-200"
                      }`}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    ›
                  </button>
                  <button
                    disabled={currentPage === totalPages || totalCount === 0}
                    className={`border p-1 px-2 rounded text-gray-500 ${currentPage === totalPages || totalCount === 0
                      ? "cursor-not-allowed bg-gray-100"
                      : "hover:bg-gray-200"
                      }`}
                    onClick={() => handlePageChange(totalPages)}
                  >
                    »
                  </button>
                </div>
              </div>
            </div>
          )}

          <Dialog
            open={open}
            onOpenChange={(isOpen) => {
              setOpen(isOpen);
              if (!isOpen) {
                setEmail("");
                setEmailError("");
                setServerSuccessMessage("");
                setServerFailureMessage("");
                setEmailSuggestions([]);
                setShowSuggestions(false);
                if (suggestTimeoutRef.current) clearTimeout(suggestTimeoutRef.current);
              }
            }}
          >
            <DialogContent className="w-full max-w-lg max-h-screen bg-white rounded-lg shadow-lg">
              <DialogHeader className="flex flex-col mb-1">
                <DialogTitle className="text-xl font-semibold">
                  {isDeleteMode ? "Delete Admin" : "Add New Admin"}
                </DialogTitle>
                <DialogDescription className="text-sm text-gray-500">
                  {isDeleteMode
                    ? "Please confirm if you want to proceed with deleting this admin."
                    : "Please enter the email of the new admin."}
                </DialogDescription>
              </DialogHeader>
              <div className="mt-1">
                <Label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-600"
                >
                  Admin Email
                </Label>
                <Input
                  id="email"
                  value={email}
                  disabled={isDeleteMode}
                  onChange={handleEmailChange}
                  placeholder="Enter admin email"
                  className="mt-2 w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                {emailError && (
                  <p className="text-red-500 text-xs mt-1">{emailError}</p>
                )}
                {serverSuccessMessage && (
                  <p className="text-green-500 text-xs mt-1">
                    {serverSuccessMessage}
                  </p>
                )}
                {serverFailureMessage && (
                  <p className="text-red-500 text-xs mt-1">
                    {serverFailureMessage}
                  </p>
                )}
                {showSuggestions && !isDeleteMode && (
                  <div className="mt-2 border rounded-md">
                    <div className="max-h-40 overflow-y-auto">
                      {isSuggestLoading ? null : (
                        emailSuggestions.length > 0 ? (
                          emailSuggestions.map((em) => (
                            <button
                              key={em}
                              type="button"
                              className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100"
                              onClick={() => {
                                setEmail(em);
                                setEmailError("");
                                setEmailSuggestions([]);   // clear items
                                setShowSuggestions(false); // CLOSE the panel
                              }}
                            >
                              {em}
                            </button>
                          ))
                        ) : (
                          <div className="px-3 py-2 text-sm text-gray-500">No matches found</div>
                        )
                      )}
                    </div>
                  </div>
                )}





              </div>
              <DialogFooter className="flex justify-between gap-2 -mt-3">
                <Button
                  variant="outline"
                  className="w-1/2 cursor-pointer"
                  onClick={handleCloseDialog}
                >
                  Cancel
                </Button>
                <Button
                  className="w-1/2 cursor-pointer"
                  disabled={!!emailError || isLoading}
                  onClick={() => handleSubmit()}
                >
                  {isDeleteMode
                    ? "Confirm"
                    : isLoading
                      ? "Adding..."
                      : "Add Admin"}
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </>
      )}
    </div>
  );
};

export default Team;
